import React from 'react';

import WarningIcon from '@mui/icons-material/Warning';
import { Grid, Tooltip, Typography } from '@sunwisesoftware/sunwise-ui';
import { useTranslation } from 'react-i18next';

import { useBreakpoint } from 'common/hooks';

import EmailFormatter from './EmailFormatter';

const StatusFormatter = (cell, t) => (
    <>
        {cell && (
            <Grid container>
                <Grid size={6}>
                    <Typography variant="subtitle2" title={cell && cell.status}>
                        {cell ? cell.status : '- - -'}
                    </Typography>
                </Grid>

                {cell.has_tmp_password && (
                    <Grid size={6}>
                        <Typography>
                            <Tooltip
                                arrow
                                title={t('Active temporary password')}
                            >
                                <WarningIcon />
                            </Tooltip>
                        </Typography>
                    </Grid>
                )}
            </Grid>
        )}
    </>
);

const ProductColumns = () => {
    const { t } = useTranslation();
    const breakpoint = useBreakpoint();
    const nameColumn = [
        {
            align: 'left',
            field: 'full_name',
            headerName: t('Name'),
            width: 200,
        },
    ];

    let columns = [
        ...nameColumn,
        {
            align: 'left',
            field: 'email',
            flex: 1,
            headerName: t('Mail'),
            renderCell: (params) => {
                const { row } = params;
                return <EmailFormatter email={row.email} />;
            },
        },
        {
            align: 'left',
            field: 'company_group_name',
            flex: 1,
            headerName: t('Role'),
        },
        {
            align: 'left',
            field: 'company_group_level',
            headerName: t('Rol level'),
        },
        {
            align: 'left',
            field: 'created_at',
            flex: 1,
            headerName: t('Creation date'),
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Typography variant="caption">{row.created_at}</Typography>
                );
            },
        },
        {
            align: 'left',
            field: 'is_enabled',
            flex: 1,
            headerName: t('Status'),
            renderCell: (params) => {
                const { row } = params;
                return StatusFormatter(row.is_enabled, t);
            },
        },
    ];

    if (['xs', 'sm'].includes(breakpoint)) {
        columns = nameColumn;
    }

    return columns;
};

export default ProductColumns;
